(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kapow-filter-toggle')) {
    customElements.define('kapow-filter-toggle', class extends HTMLElement {
      static states = new Map();
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button || this.boundButton === button) return;
        this.boundButton = button;
        const key = this.dataset.section;
        button.setAttribute('aria-expanded', String(this.constructor.states.get(key) || false));
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(expanded));
          this.constructor.states.set(key, expanded);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
